import PolicyLayout from "../components/PolicyLayout";

const sections = [
  {
    heading: "Refund & Cancellation Terms",
    paragraphs: [
      "You understand and agree that the Transaction can be cancelled by You or the Seller in the following scenarios:",
    ],
    items: [
      "The Seller does not have the product selected by You, due to unavailability of stock.",
      "You are situated outside the geographic location within which the Seller cannot undertake to deliver the Product.",
      "The address mentioned by You for delivery is incorrect and/or there is a change in your address.",
      "The Seller does not make any attempt in initiating the delivery of your product, within 3 (three) days from the date on which You receive SMS/Email communication from Finncube Credit Services Pvt. Ltd. regarding confirmation of the Transaction.",
      "Seller requests cancelation of the Transaction to Finncube Credit Services Pvt. Ltd. because You returned a defective product which cannot be replaced, as per the cancelation policy of Seller.",
      "Any other act/omission by You or the Seller, which renders delivery of the product impossible.",
    ],
  },
  {
    heading: "Right to Cancel",
    paragraphs: [
      "You understand and agree that once You receive a SMS/Email confirmation for delivery of the product from Finncube Credit Services Pvt. Ltd., You will cease to have any right to cancel the Transaction.",
    ],
  },
  {
    heading: "Seller Responsibility",
    paragraphs: [
      "Subject to above conditions, You understand that the Seller shall be solely responsible for quality/quantity/merchantability/delivery/installation/replacement of the product and that Finncube Credit Services Pvt. Ltd. shall not be liable in any manner whatsoever for any delay or other issues that may arise in relation to the product.",
    ],
  },
  {
    heading: "Escalation Window",
    paragraphs: [
      "Finncube Credit Services Pvt. Ltd. is not liable to provide a solution to any escalation received post 30 days of the delivery of the product.",
    ],
  },
  {
    heading: "Contact for Clarification",
    paragraphs: [
      "For any clarification/queries in relation to the Cancellation Terms or to address any grievance in relation to the Transaction, please write to care@finncube.com",
    ],
  },
];

function RefundCancellationPolicy() {
  return (
    <PolicyLayout
      title="Refund & Cancellation Terms"
      intro="This policy explains the conditions under which a transaction may be cancelled, the limits on cancellation after delivery confirmation, and the responsibilities of the Seller in relation to the product."
      lastUpdated="April 25, 2026"
      sections={sections}
    />
  );
}

export default RefundCancellationPolicy;
